import { render, staticRenderFns } from "./compute-quota.vue?vue&type=template&id=09e89919&scoped=true&"
import script from "./compute-quota.vue?vue&type=script&lang=js&"
export * from "./compute-quota.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09e89919",
  null
  
)

export default component.exports